import { render, staticRenderFns } from "./MaterialDropdown.vue?vue&type=template&id=4c6ec158"
import script from "./MaterialDropdown.vue?vue&type=script&lang=js"
export * from "./MaterialDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports